import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { getUserWallet } from '@/store/wallet/actions';
import { selectWalletError } from '@/store/wallet/selectors';
import { BffErrorCode } from '@lucky7ventures/bff-types';
import { MODALS } from '@/features/modal/types';
import { useModal } from '@/features/modal/useModal';

export const useWalletLoader = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();
  const walletError = useSelector(selectWalletError);
  const { openModal } = useModal();

  useEffect(() => {
    if (walletError === BffErrorCode.GIG_CONSENT_USER_HASPENDINGCONSENTS) {
      openModal(MODALS.CONSENTS);
    }
  }, [walletError]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    dispatch(getUserWallet());
  }, [isAuthenticated]);
};
